import React from 'react';
import { Link } from 'react-router-dom';

const SETTING_SECTIONS = [
  {
    icon: '👤',
    title: 'User Management',
    desc: 'View all users, change global roles (admin / qa_manager / qa_lead / tester / viewer), and manage access.',
    to: '/settings/users',
    color: '#7c3aed',
    bg: '#ede9fe',
  },
  {
    icon: '🔑',
    title: 'Roles & Permissions',
    desc: 'View the full permissions matrix for global and project-level roles. Understand what each role can do.',
    to: '/settings/roles',
    color: '#059669',
    bg: '#d1fae5',
  },
  {
    icon: '👥',
    title: 'Teams',
    desc: 'Create teams, add members, and assign teams to projects with specific roles.',
    to: '/teams',
    color: '#0891b2',
    bg: '#e0f2fe',
  },
  {
    icon: '🔗',
    title: 'JIRA Integration',
    desc: 'Connect to Atlassian JIRA — link requirements, file bugs, and sync issue status.',
    to: '/jira',
    color: '#2563eb',
    bg: '#dbeafe',
  },
  {
    icon: '⬇️',
    title: 'JIRA Import & Search',
    desc: 'Bulk-import JIRA issues as requirements, or search issues with JQL.',
    to: '/jira/import',
    color: '#0891b2',
    bg: '#e0f2fe',
  },
  {
    icon: '🔧',
    title: 'Jenkins Integration',
    desc: 'Connect to Jenkins CI to trigger builds and sync test run results.',
    to: '/jenkins',
    color: '#d97706',
    bg: '#fef3c7',
  },
];

export default function GlobalSettings() {
  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">⚙️ Global Settings</h1>
          <p className="page-subtitle">Manage workspace-level integrations and configuration.</p>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row g-3">
          {SETTING_SECTIONS.map(s => (
            <div className="col-md-4" key={s.to}>
              <Link to={s.to} style={{ textDecoration: 'none' }}>
                <div
                  className="card h-100"
                  style={{ cursor: 'pointer', transition: 'box-shadow .15s, transform .15s' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,.1)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
                >
                  <div className="card-body">
                    <div style={{
                      width: 48, height: 48, borderRadius: 10, marginBottom: 14,
                      background: s.bg, display: 'flex', alignItems: 'center',
                      justifyContent: 'center', fontSize: 24,
                    }}>
                      {s.icon}
                    </div>
                    <h6 style={{ fontWeight: 700, marginBottom: 6, color: 'var(--zq-text)' }}>{s.title}</h6>
                    <p style={{ fontSize: 13, color: 'var(--zq-text-secondary)', marginBottom: 16 }}>{s.desc}</p>
                    <span style={{ fontSize: 13, color: s.color, fontWeight: 600 }}>Configure →</span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
